import { render, staticRenderFns } from "./Pix.vue?vue&type=template&id=018bebde&"
import script from "./Pix.vue?vue&type=script&lang=js&"
export * from "./Pix.vue?vue&type=script&lang=js&"
import style0 from "./Pix.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./Pix.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/data/vstsagent/user/4158/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('018bebde')) {
      api.createRecord('018bebde', component.options)
    } else {
      api.reload('018bebde', component.options)
    }
    module.hot.accept("./Pix.vue?vue&type=template&id=018bebde&", function () {
      api.rerender('018bebde', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/steps/PaymentMethods/Pix.vue"
export default component.exports